var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99999 16C9.90893 16 9.81792 15.9773 9.73635 15.9319C9.64776 15.8827 7.54293 14.7052 5.4079 12.9309C4.14249 11.8793 3.13238 10.8363 2.4057 9.83094C1.46535 8.52996 0.992462 7.27858 1.00009 6.1115C1.00902 4.75348 1.51383 3.47635 2.42163 2.51533C3.34476 1.53813 4.5767 1 5.89059 1C7.57446 1 9.11398 1.90885 10 3.34858C10.8861 1.90888 12.4256 1 14.1095 1C15.3508 1 16.5351 1.48555 17.4443 2.36724C18.4422 3.33479 19.0092 4.70189 18.9999 6.11794C18.9922 7.28298 18.5105 8.53247 17.568 9.83165C16.8391 10.8365 15.8304 11.8791 14.57 12.9303C12.4427 14.7044 10.353 15.8819 10.2651 15.9312C10.1832 15.977 10.0915 16 9.99999 16Z",
    stroke: "#29185E",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartPurple);
export default __webpack_public_path__ + "static/media/heart-purple.b46b33b773effe78e4063c122e16cccc.svg";
export { ForwardRef as ReactComponent };